import { createPortal } from 'react-dom';
import { IconClose } from '../icons';

/* Rendered into <body> rather than in place: the overlay is position:fixed, and
   any ancestor with a transform/filter/backdrop-filter (the sign-up card has
   one) would become its containing block and shrink the dim to that element. */
export default function Modal({ open, onClose, title, footer, children, maxWidth }) {
  return createPortal(
    <div
      className={`modal-overlay ${open ? 'on' : ''}`}
      onClick={(e) => {
        if (e.target === e.currentTarget) onClose();
      }}
    >
      <div className="modal-box" style={maxWidth ? { maxWidth } : undefined}>
        <div className="modal-head">
          <h3>{title}</h3>
          <button className="modal-close" onClick={onClose}>
            <IconClose />
          </button>
        </div>
        <div className="modal-body">{children}</div>
        {footer && <div className="modal-foot">{footer}</div>}
      </div>
    </div>,
    document.body
  );
}
